export const mleTheme = ({
  breakpoints: {
    mle: '1200px'
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: 'bold',
        color: 'white'
      },
      variants: {
        'header-btn': {
          _focusVisible: {
            outline: '2px solid #0b0c0c',
            outlineOffset: '-3px'
          }
        },
        mle: {
          h: '48px',
          w: {
            base: '160px',
            mle: '210px'
          },
          fontSize: '20px',
          fontWeight: '500',
          bg: 'linear-gradient(104deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%)',
          _focusVisible: {
            outline: '3px solid #3477c7',
            outlineOffset: '2px'
          },
          _hover: {
            bg: '#fd7849',
            _disabled: {
              bg: 'linear-gradient(104deg, #00ABE8 -2.03%, #007ACC 43.7%, #0063A7 105.46%)'
            }
          }
        }
      }
    },
    Progress: {
      baseStyle: (props) => {
        return {
          filledTrack: {
            bg: props.colorScheme
          },
          track: {
            backgroundColor: 'white',
            border: '1px solid #DBE0E6',
            borderRadius: '20px'
          }
        };
      }
    }
  }
});
